import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ProvideAuth } from "@warden-ui/common";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";
import '@warden-ui/i18n';
import "./index.scss";
import * as Page from "./pages";

import { initializeLogger } from "@warden-ui/common";
import { CupixThemeContext } from "@warden-ui/common-components";

initializeLogger();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <Page.Signin />,
  },
  {
    path: '/authorize',
    element: <Page.Signin oauthFlow={true} />,
  },
  {
    path: '/signin/federated',
    element: <Page.FederatedSignIn />,
  },
  {
    path: '/signin/password',
    element: <Page.SigninPassword />,
  },
  {
    path: '/signin/mfa',
    element: <Page.SigninMfa />,
  },
  {
    path: '/reset_password/request',
    element: <Page.ResetPasswordRequest />,
  },
  {
    path: '/reset_password/code',
    element: <Page.ResetPasswordCode />,
  },
  {
    path: '/reset_password/submit',
    element: <Page.ResetPasswordSubmit />,
  },
  {
    path: '/signout',
    element: <Page.Signout />,
  },
  {
    path: '/redirect',
    element: <Page.RedirectToRedirectUri />,
  },
  {
    path: '/teams/domain',
    element: <Page.TeamDomain />,
  },
  {
    path: '/teams/choose',
    element: <Page.TeamChoose />,
  },
  {
    path: '/teams/find',
    element: <Page.TeamFind />,
  },
  {
    path: '/teams/find/sent',
    element: <Page.TeamFindSent />,
  },
  {
    path: '/users/update',
    element: <Page.UserUpdate />,
  },
  {
    path: '/users/join',
    element: <Page.UserJoin/>,
  },
]);

root.render(
  <React.StrictMode>
    <CupixThemeContext.Provider value="cupixworks">
      <ThemeProvider theme={theme}>
        <ProvideAuth>
          <RouterProvider router={router} />
        </ProvideAuth>
      </ThemeProvider>
    </CupixThemeContext.Provider>
  </React.StrictMode>
);